<template>
    <div class='footnotes'>
        <p>
            The data on the Active Incidents page is provided publicly by
            <a
                href='https://www.toronto.ca/community-people/public-safety-alerts/alerts-notifications/toronto-fire-active-incidents/'>the
                City of Toronto's website</a>.
        </p>
        <p>
            The data on the Fire Stations page is provided publicly by
            <a href='https://open.toronto.ca/'>the City of Toronto's Open Data portal</a>.
            It contains information licensed under the
            <a href='https://open.toronto.ca/open-data-licence/'>Open Government Licence - Toronto</a>.
            The data is combined with information from the
            <a href='https://fire.fandom.com/wiki/Toronto_Fire_Services'>Toronto Fire Service's Fandom wiki</a>
            licensed under the
            <a href='https://creativecommons.org/licenses/by-sa/3.0/'>Creative Commons Attribution-ShareAlike 3.0
                Unported License</a>.
        </p>
        <p>
            I take no responsibility for any inaccuracies, or misuse of any data. Some incidents may not be shown on the
            maps. For example, it is possible that a unit "Dispatched" to an incident has since cleared from it. And a unit "Cleared"
            from an incident may not necessarily be available for another.
        </p>
        <p>
            <a href='https://www.here.com/'>HERE Technologies</a> provides geocoded location data for the maps.
            The <a href='https://www.esri.com/en-us/home'>Environmental Systems Research Institute (esri)</a> provides
            the (light topographical) map of Active Incidents.
        </p>
        <p>
            <a href="mailto:justsomedevmedia%40gmail%2Ecom">Email Alvin</a> if you have any questions, comments, or
            concerns.
        </p>
        <p>Version 2.4.0.</p>
    </div>
</template>

<style scoped>
.footnotes {
    font-family: sans-serif;
    font-size: 0.8em;
    padding-top: 1em;
}

.footnotes p {
    margin: 1em;
}
</style>